import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/hooks/useAuth'
import Navbar from './Navbar'

export default function Layout() {
  const { isAuthenticated } = useAuthStore()

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  )
}